import { useUserInfoStore } from '@/store/user/slice';
import { setArmsConfig } from '@/utils/arms';
import { getServerDeviceIdForRequest, getTouristDeviceIdForRequest } from '@/utils/device/server-device-id';
import { buildH5CommonParams } from '@/utils/fetch/build-common-params';

import packageJson from '../../package.json';

/**
 * 将当前用户与设备上下文同步到 ARMS（user.name = user_id，其余进 properties）。
 * 需在游客登录成功或 store 中已有 user_id 后调用；可重复调用（如正式登录、登出后）。
 */
export async function syncArmsConfig(extra?: Record<string, unknown>): Promise<void> {
    const { userInfo, isLogin } = useUserInfoStore.getState();
    const user_id = userInfo.user_id?.trim();
    if (!user_id) {
        return;
    }

    const [common, tourist_device_id, server_device_id] = await Promise.all([
        buildH5CommonParams(),
        getTouristDeviceIdForRequest(),
        getServerDeviceIdForRequest(),
    ]);

    setArmsConfig({
        user: {
            name: user_id,
        },
        properties: {
            h5Version: packageJson.version,
            user_id,
            login_source: userInfo.login_source,
            isLogin,
            ...(tourist_device_id ? { tourist_device_id } : {}),
            ...(server_device_id ? { server_device_id } : {}),
            ...common,
            ...extra,
        },
    });
}
